<template>
    <div :style="isMobile || backgroundImage" class="banner">
        <div class="container-banner">
            <div :style="!isMobile || backgroundImage" :class="['text-info pt-5 pb-6', !isMobile || 'content-box']">
                <!-- <span class="slug-title">{{ slugInfo.title }}</span> -->
                <h1 class="description">
                    {{ slugInfo.description }}
                </h1>
                <h2 class="sub-description">
                    {{ slugInfo.subtitle }}
                </h2>
            </div>
            <Form :slugInfo="slugInfo" />
        </div>
    </div>
</template>

<script>
import Form from '@/components/landing-page/form';
import { computed } from '@vue/composition-api';
export default {
    name: 'Banner',
    props: {
        isMobile: [Boolean, Object],
        slugInfo: {
            type: Object,
            default: () => {
                return {};
            }
        }
    },
    components: { Form },
    setup(props) {
        const backgroundImage = computed(() => {
            return {
                'background-image': `linear-gradient(0deg, rgba(15, 45, 83, 0.40),
                    rgba(15, 45, 83, 1)), url(${props.slugInfo.imageUrl})`,
                'background-repeat': 'no-repeat',
                'background-size': 'cover'
            };
        });

        const containerBanner = computed(() => (props.isMobile ? 'grid' : ''));

        return { backgroundImage, containerBanner };
    }
};
</script>

<style lang="scss" scoped>
.container-banner {
    @apply content-box flex justify-between pt-10;
    @media screen and (max-width: 1023px) {
        @apply p-0;
    }
    @media screen and (max-width: 767px) {
        @apply flex-col;
    }
}
.slug-title {
    text-transform: uppercase !important;
    font-style: italic;

    font-size: 12px;
    font-weight: 600;
    padding: 9px 8px;
    border: none;
    border-radius: 3px;
    box-shadow: none !important;

    color: #fff;
    background-color: #007bff;
}

.content-box {
    @apply container mx-auto px-8;
}
.banner {
    width: 100%;
    height: 398px;
}
.description {
    margin-top: 15px;

    font-family: Open Sans;
    font-style: normal;
    font-weight: bold;
    font-size: 45px;
    text-transform: uppercase;
    line-height: 1.1em;

    /* color: #000; */
    color: #fff;
}
.sub-description {
    font-family: Open Sans;
    font-style: normal;
    font-weight: 600;
    color: #ffffff;
    line-height: 1.2em;
    font-size: 24px;
}
.text-info {
    width: 50%;
    @media screen and (max-width: 767px) {
        padding-top: 64px !important;
        padding-bottom: 64px !important;
    }
}
.container {
    // width: 90%;
}

@media screen and (max-width: 1023px) {
    .description {
        font-size: 35px !important;
    }
    .sub-description {
        font-size: 20px !important;
    }
}
@media screen and (max-width: 992px) {
    .banner {
        height: 100%;
    }
    .description {
        font-size: 28px !important;
    }
    .text-info {
        width: 100%;
        padding-top: 32px;
        padding-bottom: 32px;
    }
}
</style>
